import { render, staticRenderFns } from "./MediaBaseInfo.vue?vue&type=template&id=79f855f4&scoped=true&"
import script from "./MediaBaseInfo.vue?vue&type=script&lang=js&"
export * from "./MediaBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./MediaBaseInfo.vue?vue&type=style&index=0&id=79f855f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f855f4",
  null
  
)

export default component.exports